import * as React from 'react'
import type { FileExtension } from '../../../shared/domain/files/fileExtensions.no-deps'

export const SVG_File = ({ extension }: { extension?: FileExtension }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="65" viewBox="0 0 50 65">
        <g fill="none" fillRule="evenodd">
            <path
                fill="#E8F1F9"
                d="M.497 3.883C.497 1.74 2.25 0 4.414 0h28.727l16.32 13.593v47.25c0 2.146-1.752 3.883-3.918 3.883H4.414c-2.164 0-3.917-1.737-3.917-3.883V3.883z"
            />
            <path fill="#CCD7E2" d="M33.141 0v9.71c0 2.144 1.751 3.883 3.917 3.883h12.404" />
            {extension && (
                <text fill="#7E8B9E" fontFamily="inherit" fontSize="17.5" fontWeight="800" transform="translate(.497)">
                    <tspan x="12.503" y="45">
                        {extension.replace(/\./, '')}
                    </tspan>
                </text>
            )}
        </g>
    </svg>
)
